import { render, staticRenderFns } from "./addDetail.vue?vue&type=template&id=3b3b7014&scoped=true&"
import script from "./addDetail.vue?vue&type=script&lang=js&"
export * from "./addDetail.vue?vue&type=script&lang=js&"
import style0 from "./addDetail.vue?vue&type=style&index=0&id=3b3b7014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b7014",
  null
  
)

export default component.exports